import type {CornerDotType, CornerSquareType, DotType} from 'qr-code-styling'
import type {QrGradientStop, QrLogoState, QrStyleState} from '../utils/qrRenderer'

export interface QrDotTypeOption {
  id: DotType
  labelKey: string
}

export const QR_DOT_TYPE_OPTIONS: readonly QrDotTypeOption[] = [
  {id: 'square', labelKey: 'square'},
  {id: 'dots', labelKey: 'dots'},
  {id: 'rounded', labelKey: 'rounded'},
  {id: 'classy', labelKey: 'classy'},
  {id: 'classy-rounded', labelKey: 'classyRounded'},
  {id: 'extra-rounded', labelKey: 'extraRounded'},
]

// Pairs each dot pattern with a visually coherent corner style, mirroring the
// preset combinations shown on the qr-code-styling demo site.
export const CORNER_SQUARE_BY_DOT_TYPE: Record<DotType, CornerSquareType> = {
  square: 'square',
  dots: 'dot',
  rounded: 'extra-rounded',
  classy: 'square',
  'classy-rounded': 'extra-rounded',
  'extra-rounded': 'extra-rounded',
}

export const CORNER_DOT_BY_DOT_TYPE: Record<DotType, CornerDotType> = {
  square: 'square',
  dots: 'dot',
  rounded: 'dot',
  classy: 'square',
  'classy-rounded': 'dot',
  'extra-rounded': 'dot',
}

export const DEFAULT_QR_GRADIENT: QrGradientStop[] = [
  {id: 'g_a', color: '#7c5cff', position: 0},
  {id: 'g_b', color: '#a78bfa', position: 1},
]

export const DEFAULT_QR_STYLE: QrStyleState = {
  dotType: 'rounded',
  colorMode: 'solid',
  color: '#151221',
  gradient: DEFAULT_QR_GRADIENT,
  gradientAngle: 135,
  bgTransparent: false,
  bgColor: '#ffffff',
}

export const DEFAULT_QR_LOGO: QrLogoState = {
  enabled: false,
  imageUrl: null,
  size: 0.32,
  margin: 6,
}

export const QR_LOGO_SIZE_RANGE = {min: 0.15, max: 0.45, step: 0.01}
export const QR_LOGO_MARGIN_RANGE = {min: 0, max: 20, step: 1}
export const QR_GRADIENT_ANGLE_RANGE = {min: 0, max: 360, step: 1}
